<template>
  <div class="container">
    <h1>实用工具集</h1>

    <div style="margin-top: 50px;">
      <div class="tool-section">
        <h2>IP查询</h2>
        <div class="tool-content">
          <div class="controls">
            <input type="search" v-model="ipContent" min="1" max="32" />
            <button @click="queryIp">查询</button>
          </div>
          <div class="result">{{ ipDetails }}</div>
        </div>
      </div>

      <div class="tool-section">
        <h2>随机汉字生成器</h2>
        <div class="tool-content">
          <div class="controls">
            <input type="number" v-model.number="chineseCount" min="1" max="100" />
            <button @click="generateChineseChars">生成</button>
          </div>
          <div class="result">{{ randomChineseChars }}</div>
        </div>
      </div>

      <div class="tool-section">
        <h2>随机字符串生成器</h2>
        <div class="tool-content">
          <div class="controls">
            <input type="number" v-model.number="stringLength" min="1" max="100" />
            <div class="checkboxes">
              <label>
                <input type="checkbox" v-model="includeUppercase"> 大写字母
              </label>
              <label>
                <input type="checkbox" v-model="includeLowercase"> 小写字母
              </label>
              <label>
                <input type="checkbox" v-model="includeNumbers"> 数字
              </label>
              <label>
                <input type="checkbox" v-model="includeSpecial"> 特殊字符
              </label>
            </div>
            <div class="button-group">
              <button @click="generateRandomString">生成</button>
              <CopyButton
                  v-if="randomString && randomString !== '请至少选择一种字符类型'"
                  :text="randomString"
              />
            </div>
          </div>
          <div class="result">{{ randomString }}</div>
        </div>
      </div>

      <div class="tool-section">
        <h2>JSON 格式化工具</h2>
        <div class="tool-content">
          <div class="json-container">
            <textarea v-model="jsonInput" placeholder="请输入 JSON 字符串"></textarea>
            <div class="json-buttons">
              <button @click="formatJSON">格式化</button>
              <button @click="minifyJSON">压缩</button>
            </div>
            <pre class="json-output">{{ formattedJSON }}</pre>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CopyButton from '../components/CopyButton.vue'
import {getIp, queryIp} from '@/api'

export default {
  components: {
    CopyButton
  },
  data() {
    return {
      //ip查询
      ipContent: '',
      ipDetails: '',

      // 随机汉字
      chineseCount: 1,
      randomChineseChars: '',

      // 随机字符串
      stringLength: 16,
      includeUppercase: true,
      includeLowercase: true,
      includeNumbers: true,
      includeSpecial: false,
      randomString: '',

      // JSON 格式化
      jsonInput: '',
      formattedJSON: ''
    }
  },
  mounted() {
    this.initIp()
  },
  methods: {
    async initIp(){
      const res = await getIp()
      this.ipContent = res.data
      await this.queryIp();
    },
    async queryIp() {
      const res = await queryIp(this.ipContent);
      this.ipDetails = res.data;
    },

    generateChineseChars() {
      const chars = []
      for (let i = 0; i < this.chineseCount; i++) {
        const unicode = Math.floor(Math.random() * (0x9FFF - 0x4E00) + 0x4E00)
        chars.push(String.fromCharCode(unicode))
      }
      this.randomChineseChars = chars.join('')
    },

    generateRandomString() {
      const uppercase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
      const lowercase = 'abcdefghijklmnopqrstuvwxyz'
      const numbers = '0123456789'
      const special = '!@#$%^&*()_+-=[]{}|;:,.<>?'

      let chars = ''
      if (this.includeUppercase) chars += uppercase
      if (this.includeLowercase) chars += lowercase
      if (this.includeNumbers) chars += numbers
      if (this.includeSpecial) chars += special

      if (!chars) {
        this.randomString = '请至少选择一种字符类型'
        return
      }

      let result = ''
      for (let i = 0; i < this.stringLength; i++) {
        result += chars.charAt(Math.floor(Math.random() * chars.length))
      }
      this.randomString = result
    },

    formatJSON() {
      try {
        const obj = JSON.parse(this.jsonInput)
        this.formattedJSON = JSON.stringify(obj, null, 2)
      } catch (e) {
        this.formattedJSON = '无效的 JSON 格式'
      }
    },

    minifyJSON() {
      try {
        const obj = JSON.parse(this.jsonInput)
        this.formattedJSON = JSON.stringify(obj)
      } catch (e) {
        this.formattedJSON = '无效的 JSON 格式'
      }
    }
  }
}
</script>

<style>
.container {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
}

h1 {
  text-align: center;
  color: #2c3e50;
}

.tool-section {
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

h2 {
  margin-top: 0;
  color: #34495e;
}

.tool-content {
  margin-top: 15px;
}

.controls {
  margin-bottom: 15px;
}

input[type="number"] {
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  margin-right: 10px;
}

input[type="search"] {
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  margin-right: 10px;
}

button {
  background-color: #3498db;
  color: white;
  border: none;
  padding: 8px 15px;
  border-radius: 4px;
  cursor: pointer;
  margin-right: 10px;
}

button:hover {
  background-color: #2980b9;
}

.button-group {
  display: flex;
  gap: 10px;
  margin-top: 10px;
}

.button-group button:last-child {
  margin-right: 0;
}

.result {
  padding: 15px;
  background: #f8f9fa;
  border-radius: 4px;
  min-height: 40px;
  word-break: break-all;
}

.checkboxes {
  margin: 10px 0;
}

.checkboxes label {
  margin-right: 15px;
}

.json-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

textarea {
  width: 100%;
  height: 150px;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-family: monospace;
}

.json-buttons {
  display: flex;
  gap: 10px;
}

.json-output {
  padding: 15px;
  background: #f8f9fa;
  border-radius: 4px;
  white-space: pre-wrap;
  font-family: monospace;
  margin: 0;
}
</style>
